import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="256"
    height="256"
    viewBox="0 0 256 256"
  >
    <g
      fill="currentColor"
      strokeMiterlimit="10"
      strokeWidth="0"
      transform="translate(1.407 1.407)scale(2.81)"
    >
      <path d="m49.083 71.489 5.776-21.96 4.186-15.247c3.497-16.18-32.704-2.439-38.002 1.695l.425 4.853c4.824-3.395 23.091-7.744 19.449 4.275l-1.634 6.135-8.329 31.071c-3.497 16.18 32.704 2.439 38.002-1.695l-.425-4.853c-4.823 3.396-23.09 7.745-19.448-4.274"></path>
      <circle cx="53.871" cy="11.201" r="11.201"></circle>
    </g>
  </svg>
);

export default SvgIcon;
